import { useEventRegistrationSettings } from '~/entities/event/model/use-registrations'
import { useEventTicketTypes } from '~/entities/ticket/model/use-tickets'

/** Whether the saved event has Pulsify tickets or a Pulsify sign-up; undefined while loading. */
export function useSavedConfirmationStep(businessId: string, eventId: string): boolean | undefined {
  const types = useEventTicketTypes(businessId, eventId)
  const registration = useEventRegistrationSettings(businessId, eventId)
  if (!types.data || !registration.data) return undefined
  return types.data.length > 0 || registration.data.config.enabled
}
